module.exports = __webpack_public_path__ + "d7df242fd50379876e2339a0c59d440d.png";